module.exports = __webpack_public_path__ + "img/scroll-up-orange.a4a09240.svg";